import { useEffect, useState } from 'react';
import apiClient from '../lib/apiClient';

const DEFAULT_SITE_STATUS = { coming_soon: false, checked: false };

function applyTheme(theme = {}) {
  const root = document.documentElement;
  const variables = {
    primary: '--primary',
    secondary: '--secondary',
    accent: '--accent',
    background: '--background',
    foreground: '--foreground',
    card: '--card',
    muted: '--muted',
    border: '--border',
    border_radius: '--radius',
  };

  Object.entries(variables).forEach(([key, cssVariable]) => {
    if (theme[key]) root.style.setProperty(cssVariable, theme[key]);
  });
}

/**
 * Loads public platform bootstrap data once at application start.
 * Failure is deliberately non-blocking: the public site remains available
 * with default theme tokens and coming-soon mode disabled.
 */
export default function useSiteBootstrap() {
  const [siteStatus, setSiteStatus] = useState(DEFAULT_SITE_STATUS);

  useEffect(() => {
    let active = true;

    const bootstrap = async () => {
      const [statusResult, themeResult] = await Promise.allSettled([
        apiClient.get('/api/site/status'),
        apiClient.get('/api/customization/theme'),
      ]);

      if (!active) return;

      if (statusResult.status === 'fulfilled') {
        setSiteStatus({ ...statusResult.value.data, checked: true });
      } else {
        setSiteStatus({ coming_soon: false, checked: true });
      }

      if (themeResult.status === 'fulfilled') {
        applyTheme(themeResult.value.data);
      }
    };

    bootstrap();
    return () => { active = false; };
  }, []);

  return siteStatus;
}

export { applyTheme, DEFAULT_SITE_STATUS };
